import React from 'react';
import Star from '../icons/Star';
const card = ({
	img,
	author_name,
	book_name,
	filled,
	review,
	desc,
	price,
	cutPrice,
}) => {
	const isfilled = [false, false, false, false, false];

	for (let i = 0; i < filled; i++) {
		isfilled[i] = true;
	}

	return (
		<div className='wrapper'>
			<div className='mb'></div>
			<div className='line mb'></div>
			<div className='card_items'>
				<img className='card_img' src={img} alt='img1' />
				<div className='card_container'>
					<div className='author_name'>{author_name}</div>
					<span className='book_name'>{book_name}</span>
					<div className='star_and_review'>
						<div className='stars'>
							{isfilled.map((value, index) => {
								return (
									<Star flag={value} key={index} />
								);
							})}
						</div>

						<p className='review'>{review} review</p>
					</div>
					<p className='desc'>{desc}</p>
					<span className='price'>{price}</span>
					<span className='cut_price'>{cutPrice}</span>
				</div>
				<button className='card_button'>buy now</button>
			</div>
		</div>
	);
};

export default card;
